/**
 * @interface
 */
function Player() {
}

/**
 * @typedef Player~error
 * @property {String} [title]
 * @property {String} [message]
 * @property {Object<Function>} [actions]
 * @property {Boolean} [isEnableFlash]
 */

/**
 * @typedef Player~parameters
 * @property playerElementId
 */

/**
 * @type {String}
 */
Player.prototype.name = "";

/**
 * @callback Player~onEmbed
 * @param {Player~error|null} error
 * @param {Object|null} element
 */

/**
 * @param {Player~parameters} parameters
 * @param {Object} flashVars
 * @param {Player~onEmbed} callback
 */
Player.prototype.embed = function (parameters, flashVars, callback) {
};